function formatText(text) {
  return String(text || '')
    .split(/\r?\n/)
    .filter((line) => line.trim() !== '')
}

export function LogoFooterWidget({ payload }) {
  const labels = payload.labels || {}
  const logo = payload.logo || null
  const textLines = formatText(payload.text)

  if (!logo && !textLines.length) {
    if (!payload.showEmptyNotice) return null

    return <p className="nova-logo-footer-widget__notice">{labels.empty || 'Ajoutez un logo ou un texte dans Liste widget > Logo footer.'}</p>
  }

  return (
    <section className="nova-logo-footer-widget" aria-label={labels.aria || 'Logo footer'}>
      {logo?.src ? (
        <div className="nova-logo-footer-widget__logo">
          <img
            className="nova-logo-footer-widget__image"
            src={logo.src}
            alt={logo.alt || ''}
            width={logo.width || undefined}
            height={logo.height || undefined}
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : null}

      {textLines.length ? (
        <p className="nova-logo-footer-widget__text">
          {textLines.map((line, index) => (
            <span className="nova-logo-footer-widget__line" key={`${line}-${index}`}>
              {line}
            </span>
          ))}
        </p>
      ) : null}
    </section>
  )
}
